import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngstack/translate';
import { environment } from 'src/environments/environment';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { MatDialog, MatSelect, MatTableDataSource, MatPaginator } from '@angular/material';
import { CIDService } from 'src/app/services/common/cid.service';
import { CashService } from 'src/app/services/http/business/cash/cash.service';
import { ICompany } from 'src/app/interfaces/company';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { CashEntryComponent } from '../cash-entry/cash-entry.component';
import { IBranch } from 'src/app/interfaces/branch';
import { BIDService } from 'src/app/services/common/bid.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { ICash } from 'src/app/interfaces/cash';
import { AssignCashierComponent } from '../assign-cashier/assign-cashier.component';
import { IConfirm } from 'src/app/interfaces/confirm';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';


@Component({
  selector: 'app-cash-list',
  templateUrl: './cash-list.component.html',
  styleUrls: ['./cash-list.component.css']
})
export class CashListComponent implements OnInit {

  url = environment.BaaseUrl;
  isOwner: boolean;
  BranchEncryptId: string;
  companySelected: string;
  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  errors = new Array();
  branchList: IBranch[];
  branchSelected: string;
  companyList: ICompany[];
  hideTable: boolean = true;

  displayedColumns = [
    "title",
    "status",
    "function"
  ];
  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    public translate: TranslateService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private bidService: BIDService,
    private branchService: BranchService,
    private errorService: ErrorsService,
    private cashServicce: CashService) { }

  ngOnInit() {
    this.checkOwner();
    //this.getCashierList();
    this.getCompanyList();
    this.companySelected = this.cidService.getCID();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
    });
  }

  getCompanyList() {
    this.companyService.list(0,0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getBranchList() {
    this.branchService.listByLogin(0, 0).subscribe(res => {
      this.branchList = res.DataList;
    });
  }

  setCid(e: MatSelect) {
    this.dataSource = null;
    this.cidService.setCID(e.value);
    this.getBranchList();
  }


  loadTable(BranchEncryptId: MatSelect) {
    this.dataSource = null;
    if (this.isOwner)
      this.bidService.setBID(BranchEncryptId.value);
    this.BranchEncryptId = BranchEncryptId.value;
    this.cashServicce.list(BranchEncryptId.value, 0, 0).subscribe(res => {
      this.hideTable = false;
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }

  ative(data: ICash): void {
    let confirm: IConfirm = {
      accept: true,
      message: data.IsActive
        ? this.translate.get("confirm.inActive", {
          name: this.translate.get("label.level") + " " + "'" + data.Title + "'"
        })
        : this.translate.get("confirm.active", {
          name: this.translate.get("label.level") + " " + "'" + data.Title + "'"
        }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      var activate: any = {
        SetActive: !data.IsActive,
        Id: data.Id
      };
      if (result) {
        this.cashServicce.activeDeactive(activate).subscribe(
          () => {
            this.cashServicce.list(data.BranchEncryptId, 0, 0)
              .subscribe(re => {
                this.paginator.pageIndex = 0;
                this.dataSource = re.DataList;
                this.paginator.length = re.Total;
              });
          },
          () => {
            this.errorService.transactionError();
          }
        );
      }
    });
  }


  // getColor(e) {
  //   switch (e.IsActive) {
  //     case true:
  //       return "custom-chips primary";
  //     case false:
  //       return "custom-chips accent";
  //   }
  // }

  add(beanchId) {
    this.dialog
      .open(CashEntryComponent, {
        data: beanchId
      })
      .afterClosed()
      .subscribe(() => {
        this.cashServicce.list(this.BranchEncryptId, 0, 0).subscribe(res => {
          this.hideTable = false;
          this.dataSource = res.DataList;
          this.paginator.length = res.Total;
          this.paginator.pageIndex = 0;
          this.paginator.pageSize = 10;
        });
      });
  }

  edit(cash: ICash) {
    this.dialog
      .open(CashEntryComponent, {
        data: cash
      })
      .afterClosed()
      .subscribe(() => {
        this.cashServicce.list(this.BranchEncryptId, 0, 0).subscribe(res => {
          this.hideTable = false;
          this.dataSource = res.DataList;
          this.paginator.length = res.Total;
          this.paginator.pageIndex = 0;
          this.paginator.pageSize = 10;
        });
      });
  }

  assignPerson(cash: ICash) {
    this.dialog
      .open(AssignCashierComponent, {
        data: cash
      })
      .afterClosed()
      .subscribe(() => {
        this.cashServicce.list(this.BranchEncryptId, 0, 0).subscribe(res => {
          this.hideTable = false;
          this.dataSource = res.DataList;
          this.paginator.length = res.Total;
          this.paginator.pageIndex = 0;
          this.paginator.pageSize = 10;
        });
      });
  }

  paginatorEvent(event) {
    this.cashServicce
      .list(this.BranchEncryptId, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }
}
